import { Component, OnInit } from '@angular/core'
import { Browser, IBrowserInformation } from '@components/exportable/browser-upgrade-notice/interfaces/i-browser-information.interface'
import { supportedBrowserVersions } from '@components/exportable/browser-upgrade-notice/data/supported-browser-list'
import { BrowserUpgradeNoticeService } from '@components/exportable/browser-upgrade-notice/services/browser-upgrade-notice.service'
import { StorageService } from '@services/storage/storage.service'
import { CommonModule } from '@angular/common'
import { InlineTranslationDirective } from '@directives/inline-translation/inline-translation.directive'

@Component({
  selector: 'app-browser-upgrade-notice',
  templateUrl: './browser-upgrade-notice.component.html',
  styleUrls: ['./browser-upgrade-notice.component.scss'],
  standalone: true,
  imports: [CommonModule, InlineTranslationDirective],
})
export class BrowserUpgradeNoticeComponent implements OnInit {
  browserInformation!: IBrowserInformation
  displayUpgradeNotice!: boolean
  // eslint-disable-next-line eqeqeq
  supportedBrowserList = Object.values(Browser).filter((browser: Browser) => browser !== Browser.UNKNOWN)
  supportedVersionList = supportedBrowserVersions

  constructor(private browserUpgradeNoticeService: BrowserUpgradeNoticeService, private storageService: StorageService) {}

  ngOnInit(): void {
    this.browserInformation = this.browserUpgradeNoticeService.detectBrowser(navigator.userAgent)
    this.displayUpgradeNotice = this.storageService.getItem(navigator.userAgent, null, null, 'session')
      ? false
      : !this.browserUpgradeNoticeService.validateBrowser(this.browserInformation)
  }

  dismissWarning(): void {
    this.storageService.setItem(navigator.userAgent, new Date().toISOString(), null, 'session')
    this.displayUpgradeNotice = false
  }
}
